<template>
    <div class="rebrand-2022">
        <div class="wp-block-group is-style-grid-large"><div class="wp-block-group__inner-container">
            <div id="zb_cta-form-footer-v3_block_c1b28887461269e1069d05110561f4ba" class="zb-cta-form-footer-v3">
                <div class="zb-cta-form-footer-v3--inner">
                    <h2 v-if="h2Text" data-aos="fade-up" class="txt-title-md-alt lg_txt-title-hg title aos-init aos-animate text-center">{{ h2Text }}</h2>

                    <div data-aos="fade-up" data-aos-delay="200" class="zb-cta-form-footer-v3--form-wrapper zb-form aos-init aos-animate">

                        <div class="zb-customizable-form-and-button redirect										">
                            <form onsubmit="return false;">
                                <div class="cta-form-field-container">
                                    <div class="zb-floating-label zb-form-field">
                                        <input v-model="val" class="zb-form-input has-focus-00-background-color enter-your-trademark-serial-number" placeholder="Enter your trademark serial number" type="text">
                                    </div>
                                </div>
                                <div class="cta-button-container">

                                    <a href="#" @click.prevent="next" aria-label="Start an LLC" data-schema="cta" data-position="footer" data-destination="funnel" class="zb-button-c zb-button txt-button-lg button-growth button-primary ">
                                        Begin
                                    </a>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div></div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: String,
        h2Text: String,
    },
    methods: {
        next() {
            this.$emit('next', [])
        }
    },
    computed: {
        val: {
            get() {
                return this.modelValue
            },
            set(val) {
                this.$emit('update:modelValue', val)
            }
        }
    }
}
</script>
